import { render, staticRenderFns } from "./FormatoMedicoComponent.vue?vue&type=template&id=272752b5&scoped=true&"
import script from "./FormatoMedicoComponent.vue?vue&type=script&lang=js&"
export * from "./FormatoMedicoComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormatoMedicoComponent.vue?vue&type=style&index=0&id=272752b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272752b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSimpleTable})
